export default __webpack_public_path__ + "static/news8-f35898b5b4b35971daf178ec28adf4e4.jpeg";